import * as React from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { Checkbox, TextField } from "@mui/material";
import { Check, ChevronDown, HardDriveUploadIcon, Plus } from "lucide-react";

const Categoryheader2 = () => {
  const [brand, setbrand] = React.useState(false);
  const [category, setcategory] = React.useState(false);
  const [gender, setgender] = React.useState(false);
  const [price, setprice] = React.useState(false);
  const [city, setCity] = React.useState("");
  const [state, setstate] = React.useState("");
  const [sortby, setSortby] = React.useState("");

  const handlenbrand = event => {
    setbrand(!brand);
  };

  const handlecategory = event => {
    setcategory(!category);
  };

  const handlegender = event => {
    setgender(!gender);
  };

  const handleprice = event => {
    setprice(!price);
  };

  return (
    <div className="flex flex-row box-border h-[8.7vh] w-[100]">
      <div className="w-[100%] h-[100%] mt-[1.959259259vh] box-border px-[3.220338983%] flex flex-row">
        <FormControl sx={{ m: 1, minWidth: 180 }} size="small">
          <InputLabel id="demo-select-small-label">City</InputLabel>
          <Select
            labelId="demo-select-small-label"
            id="demo-select-small"
            value={city}
            label="City"
            onChange={e => {
              setCity(e.target.value);
            }}>
            <MenuItem value={10}>Sketchers</MenuItem>
            <MenuItem value={20}>Rebook</MenuItem>
            <MenuItem value={30}>Campus</MenuItem>
            <MenuItem value={40}>Sketchers</MenuItem>
          </Select>
        </FormControl>
        <FormControl sx={{ m: 1, minWidth: 180 }} size="small">
          <InputLabel id="demo-select-small-label">State</InputLabel>
          <Select
            labelId="demo-select-small-label"
            id="demo-select-small"
            value={state}
            label="State"
            onChange={e => {
              setstate(e.target.value);
            }}>
            <MenuItem value={10}>Sketchers</MenuItem>
            <MenuItem value={20}>Rebook</MenuItem>
            <MenuItem value={30}>Campus</MenuItem>
            <MenuItem value={40}>Sketchers</MenuItem>
          </Select>
        </FormControl>
        <FormControl sx={{ m: 1, minWidth: 180 }} size="small">
          <InputLabel id="demo-select-small-label">Sort by</InputLabel>
          <Select
            labelId="demo-select-small-label"
            id="demo-select-small"
            value={sortby}
            label="Sort by"
            onChange={e => {
              setSortby(e.target.value);
            }}>
            <MenuItem value={10}>Sketchers</MenuItem>
            <MenuItem value={20}>Rebook</MenuItem>
            <MenuItem value={30}>Campus</MenuItem>
            <MenuItem value={40}>Sketchers</MenuItem>
          </Select>
        </FormControl>
      </div>
    </div>
  );
};

export default Categoryheader2;
